var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUcoDeezerLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{fill:#40ab5d;}.cls-4{fill:url(#Unbenannter_Verlauf_10);}.cls-5{fill:url(#Unbenannter_Verlauf_2);}.cls-6{fill:url(#Unbenannter_Verlauf_3);}.cls-7{fill:url(#Unbenannter_Verlauf_5);}.cls-8{fill:url(#Unbenannter_Verlauf_7);}.cls-9{fill:url(#Unbenannter_Verlauf_6);}.cls-10{fill:url(#Unbenannter_Verlauf_7-2);}.cls-11{fill:url(#Unbenannter_Verlauf_8);}.cls-12{fill:url(#Unbenannter_Verlauf_9);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 200,
    height: 60
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_10",
    x1: -460.45,
    y1: 429.01,
    x2: -460.49,
    y2: 426.95,
    gradientTransform: "translate(896.12 -752.01) scale(1.83)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#358c7b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#33a65e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_2",
    x1: -462.24,
    y1: 431.67,
    x2: -458.7,
    y2: 429.87,
    gradientTransform: "translate(896.12 -752.01) scale(1.83)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#222b90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#367b99"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_3",
    x1: -474.64,
    y1: 433.56,
    x2: -471.2,
    y2: 433.56,
    gradientTransform: "translate(896.12 -752.01) scale(1.83)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff8000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_5",
    x1: -470.49,
    y1: 433.56,
    x2: -467.05,
    y2: 433.56,
    gradientTransform: "translate(896.12 -752.01) scale(1.83)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff8000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cc1953"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_7",
    x1: -466.33,
    y1: 433.56,
    x2: -462.9,
    y2: 433.56,
    gradientTransform: "translate(896.12 -752.01) scale(1.83)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cc1953"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#241284"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_6",
    x1: -462.19,
    y1: 433.56,
    x2: -458.75,
    y2: 433.56,
    gradientTransform: "translate(896.12 -752.01) scale(1.83)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#222b90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3559a6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_7-2",
    x1: -466.47,
    y1: 431.31,
    x2: -462.77,
    y2: 430.23,
    xlinkHref: "#Unbenannter_Verlauf_7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_8",
    x1: -470.61,
    y1: 430.1,
    x2: -466.93,
    y2: 431.44,
    gradientTransform: "translate(896.12 -752.01) scale(1.83)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fc0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ce1938"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_9",
    x1: -470.2,
    y1: 426.67,
    x2: -467.34,
    y2: 429.3,
    gradientTransform: "translate(896.12 -752.01) scale(1.83)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fd5a22"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g8252"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path8175",
    d: "M61,34.59c0,5.88,3.62,9.4,9,9.4,2.68,0,4.94-.75,6.2-2.71V44h4.92V16H76V27.89c-1.15-2-3.3-2.85-6-2.85-5.25,0-9,3.58-9,9.55Zm15.18,0c0,3.36-2.29,5.46-5,5.46s-5-2.1-5-5.46,2.19-5.56,5-5.56S76.19,31.2,76.19,34.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path8177",
    d: "M97,36.76A4.12,4.12,0,0,1,92.61,40c-2.71,0-4.94-1.65-5-4.55h12.86a10.61,10.61,0,0,0,.23-2.32c0-5.2-3.54-8.14-8.78-8.14a9,9,0,0,0-9.43,9.37c0,6,4.24,9.62,10.1,9.62,4.43,0,7.44-1.84,8.76-5.52Zm-9.4-4.69a4.24,4.24,0,0,1,4.32-3.33c2.29,0,3.85,1.23,3.85,3.17l0,.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path8179",
    d: "M115.94,36.76a4.12,4.12,0,0,1-4.4,3.26c-2.71,0-4.94-1.65-5-4.55H119.4a10.59,10.59,0,0,0,.24-2.32c0-5.2-3.55-8.14-8.79-8.14a9,9,0,0,0-9.43,9.37c0,6,4.24,9.62,10.11,9.62,4.42,0,7.43-1.84,8.75-5.52Zm-9.4-4.69a4.25,4.25,0,0,1,4.33-3.33c2.28,0,3.84,1.23,3.84,3.17l0,.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path8181",
    d: "M137.64,44V39.4H126.92l10.43-10.15V25h-16.5v4.4h10.08l-10.4,10.19V44Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path8183",
    d: "M152.56,36.76a4.12,4.12,0,0,1-4.4,3.26c-2.72,0-4.94-1.65-5-4.55H156a10.61,10.61,0,0,0,.23-2.32c0-5.2-3.55-8.14-8.78-8.14A9,9,0,0,0,138,34.38c0,6,4.24,9.62,10.1,9.62,4.43,0,7.44-1.84,8.76-5.52Zm-9.4-4.69a4.24,4.24,0,0,1,4.32-3.33c2.29,0,3.85,1.23,3.85,3.17l0,.16Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect8185",
    className: "cls-3",
    x: 49.48,
    y: 25.03,
    width: 6.29,
    height: 3.68
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect8192",
    className: "cls-4",
    x: 49.48,
    y: 30.13,
    width: 6.29,
    height: 3.68
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect8199",
    className: "cls-5",
    x: 49.48,
    y: 35.24,
    width: 6.29,
    height: 3.68
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect8206",
    className: "cls-6",
    x: 26.68,
    y: 40.34,
    width: 6.29,
    height: 3.68
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect8213",
    className: "cls-7",
    x: 34.27,
    y: 40.34,
    width: 6.29,
    height: 3.68
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect8220",
    className: "cls-8",
    x: 41.89,
    y: 40.34,
    width: 6.29,
    height: 3.68
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect8227",
    className: "cls-9",
    x: 49.48,
    y: 40.34,
    width: 6.29,
    height: 3.68
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect8234",
    className: "cls-10",
    x: 41.89,
    y: 35.24,
    width: 6.29,
    height: 3.68
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect8241",
    className: "cls-11",
    x: 34.27,
    y: 35.24,
    width: 6.29,
    height: 3.68
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect8248",
    className: "cls-12",
    x: 34.27,
    y: 30.13,
    width: 6.29,
    height: 3.68
  }), /*#__PURE__*/React.createElement("path", {
    id: "path8250",
    d: "M168.35,31.58v.55h5V30.67c0-3.25-2-5.61-5.45-5.61a4.71,4.71,0,0,0-4.56,2.84V25.06h-5.14V44h5.14V31.8c0-1.93,1-3,2.64-3A2.62,2.62,0,0,1,168.35,31.58Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUcoDeezerLogo);
export default __webpack_public_path__ + "static/media/uco-deezer-logo.cf6d8a87dde8b3b3931361a6c4a1ee33.svg";
export { ForwardRef as ReactComponent };